// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import PatientChartsPrintedFriendlySectionItemProperty from '../PatientChartsPrintedFriendlySectionItemProperty/PatientChartsPrintedFriendlySectionItemProperty'

const styles = StyleSheet.create({
  sectionSubTitle: {
    color: '#141414',
    textAlign: 'right',
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
    marginTop: 16,
  },
  intakeFormsSectionSubTitle: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica-BoldOblique',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 8,
    marginTop: 16,
  },
  intakeFormsQuestion: {
    color: '#141414',
    textAlign: 'left',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 8,
  },
  intakeFormsAnswer: {
    color: '#767676',
    textAlign: 'left',
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 16,
  },
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const PatientChartsPrintedFriendlyIntakeForms = ({ properties }) => (
  <View>
    {/*
     // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
    {properties.map(({ content, title }) => {
      const { intakeFormMainProperties, questions } = content || {}
      return (
        <View>
          <View wrap={false}>
            <Text style={styles.sectionSubTitle}>{title}</Text>
            {/*
             // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
            {intakeFormMainProperties?.map(({ name, value }) => (
              <PatientChartsPrintedFriendlySectionItemProperty name={name} value={value} />
            ))}
          </View>
          {questions?.length > 0 && <Text style={styles.intakeFormsSectionSubTitle}>Questions</Text>}
          {/*
           // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
          {questions?.map(({ question, answer }) => (
            <View wrap={false}>
              <Text style={styles.intakeFormsQuestion}>{question}</Text>
              <Text style={styles.intakeFormsAnswer}>{answer}</Text>
            </View>
          ))}
        </View>
      )
    })}
  </View>
)

export default PatientChartsPrintedFriendlyIntakeForms
